import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Col,
} from "reactstrap";
import CustomInput from "components/common/AuthInput";
import { useFormik } from "formik";
import { ErrorToaster } from "components/common/toast";
import { ForgotPasswordApi } from "network/user";
import { successToaster } from "components/common/toast";
import { useTranslation } from "react-i18next";
import BtnCustom from "components/common/btn-custom";
import handleError from "utils/handleError";
import { Link } from "react-router-dom";
import PATHS from "constant/paths";
import { ForgotPasswordSchema } from "components/schema/ForgotPasswordSchema";

const ForgotPassword = () => {
  const { t } = useTranslation("auth");
  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    isSubmitting,
    resetForm,
  } = useFormik({
    initialValues: {
      email: "",
    },
    enableReinitialize: true,
    validationSchema: ForgotPasswordSchema,

    onSubmit: async (values) => {
      try {
        const response = await ForgotPasswordApi(values);
        if (response.success) {
          successToaster(t("forgot.sent"));
          resetForm();
        }
      } catch (error) {
        ErrorToaster(handleError(error?.status_code, error?.message));
      }
    },
  });
  return (
    <>
      <div className="content">
        <Col className="ml-auto mr-auto forgot-password" lg="4" md="6">
          <Form className="form" onSubmit={handleSubmit}>
            <Card className="card-login card-white">
              <CardHeader>
                <img alt="..." src={require("assets/img/card-primary.png")} />
                <CardTitle tag="h6">{t("forgot.title")}</CardTitle>
                <p className="description">
                  {t("forgot.description")}
                </p>
              </CardHeader>
              <CardBody>
                <CustomInput
                  icon={<i className="tim-icons icon-email-85" />}
                  name="email"
                  placeholder={t("forgot.email")}
                  type="email"
                  errors={errors}
                  touched={touched}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values}
                />
              </CardBody>
              <CardFooter>
                <BtnCustom
                  block
                  className="mb-3"
                  color="primary"
                  size="lg"
                  type="submit"
                  submittingText={t("forgot.sending")}
                  isLoading={isSubmitting}
                >
                  {t("forgot.send")}
                </BtnCustom>
                <div className="text-center">
                  <Link className="link footer-link" to={PATHS.LOGIN}>
                    {t("forgot.goToLogin")}
                  </Link>
                </div>
              </CardFooter>
            </Card>
          </Form>
        </Col>
      </div>
    </>
  );
};

export default ForgotPassword;
